import { createClient } from "@supabase/supabase-js";

/* ─── Supabase client ────────────────────────────────────────────
   Configured entirely through environment variables (see .env.example):
     VITE_SUPABASE_URL       — project URL (Dashboard → Settings → API)
     VITE_SUPABASE_ANON_KEY  — anon/public key (safe for the client;
                               everything sensitive is enforced by RLS)

   Never put the service_role key anywhere in this app — it bypasses
   Row Level Security and must only live in trusted server contexts
   (Supabase dashboard, edge functions, CI secrets).

   When the env vars are absent (e.g. local dev without an account
   backend) `supabase` is null and the app runs fully local-first —
   account UI degrades to an informative message. */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
      })
    : null;

export const isSupabaseConfigured = Boolean(supabase);
